import React from "react";

import MessageWithButton from "@/ui/molecules/MessageWithButton";

import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

export type ErrorBoundaryProps = JSX.IntrinsicAttributes & {
    children: React.ReactNode;
    fallback?: React.ReactNode;
    buttonLabel?: React.ReactNode;
    buttonAction?: () => void;
};

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    override render() {
        if (this.state.hasError) {
            return (
                this.props.fallback ?? (
                    <LayoutFillParentCentered>
                        <MessageWithButton
                            variant="error"
                            message={this.state.error?.message}
                            buttonLabel={this.props.buttonLabel}
                            buttonAction={this.props.buttonAction}
                        />
                    </LayoutFillParentCentered>
                )
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
